// Is the app on a PHONE right now? (Figma "Task creation design", mobile frames m01–m48, Pouria
// 2026-10-15: "go for all page by page in both mobile and big screen size".)
//
// The phone frames are not the desktop card squeezed: the box becomes a stacked single-column card,
// the Work-board a collapsible row, the create chooser a bottom sheet, the commit a round ✓. Most of
// that is layout and is written as Tailwind `max-md:` classes; this is for the few places where the
// phone BEHAVES differently (a sheet instead of an inline row, a board that starts collapsed), which a
// class cannot express.
//
// The breakpoint is Tailwind's `md` (768px), so `isMobile` and every `max-md:` class agree on which
// side of the line the window is. Without `matchMedia` (jsdom, an old browser) it answers false: the
// desktop layout is the one every existing spec already pins.

import { onBeforeUnmount, ref } from 'vue'

export const MOBILE_QUERY = '(max-width: 767.98px)'

export function useIsMobile() {
  const mq = typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(MOBILE_QUERY)
    : null
  const isMobile = ref(!!mq?.matches)
  const onChange = (e) => { isMobile.value = !!e.matches }
  mq?.addEventListener?.('change', onChange)
  onBeforeUnmount(() => mq?.removeEventListener?.('change', onChange))
  return isMobile
}
